const NAVIGATION = [
  {
    title: 'Home',
    link: 'home',
    id: 'home'
    // menu: [
    //   {
    //     title: 'menu - faq',
    //     link: 'faq',
    //     submenu: false
    //   },
    //   {
    //     title: 'menu with submenu example',
    //     id: 'sub',
    //     link: '#',
    //     submenu: true,
    //     submenuList: [
    //       {
    //         title: 'submenu item example',
    //         link: 'faq'
    //       },
    //       {
    //         title: 'submenu item example',
    //         link: '#'
    //       }
    //     ]
    //   }
    // ]
  },
  {
    title: 'Gallery',
    link: 'gallery',
    id: 'gallery'
  },
  {
    title: 'Inventory',
    link: 'inventory',
    id: 'inventory'
  },
  {
    title: 'FAQ',
    link: 'faq',
    id: 'faq'
  },
  {
    title: 'Quote',
    link: 'quote',
    id: 'quote',
    desc: 'Request a Quote'
  }
]

module.exports = {
  NAVIGATION
}
